import Page from '../pages/model'
import api from '@/helpers/api'

export default {
    state: {

    },

    mutations: {

    },

    getters: {
        test(state, getters) {


        }
    },

    actions: {
        fetchByPositionId(store, positionId) {
            Page.dispatch('addLoader', 'knowledges.fetchByPositionId')
            return store.dispatch('fetchItems', { positionId: positionId })
                .finally(()=>{
                    Page.dispatch('removeLoader', 'knowledges.fetchByPositionId')
                })
        },
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'knowledges.fetchItems')

            return api.get('/api/v1/knowledgevolume', {params}).then((res)=>{
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'knowledges.fetchItems')
            })
        },
        create (store, data) {
            Page.dispatch('addLoader', 'knowledges.create')

            return api.post('/api/v1/knowledgevolume', data).then((res)=>{
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'knowledges.create')
            })
        },
        update (store, data) {
            Page.dispatch('addLoader', 'knowledges.update')

            return api.post('/api/v1/knowledgevolume/Update', data).then((res)=>{
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'knowledges.update')
            })
        },
        save (store, data) {
            return store.dispatch(data.id ? 'update' : 'create', data)
        }
    }
}
